// ======================================================================
// File Name       : UserAttributeAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as userAttributeRequests from './httpRequests/userAttribute';
import * as ActionTypes from '../constants/actionTypes/userAttribute';
import { MODE } from '../constants/index';

export function initUserAttributeEditing(userAttributeType, secernId) {
  if (userAttributeType && secernId) {
    return dispatch =>
      userAttributeRequests
        .postUserAttributeGetList({
          searchInfo: { userAttributeType, secernId },
        })
        .then(({ userAttributeList }) => {
          dispatch(doReceiveUserAttributeList(userAttributeList));
          dispatch(doInitUserAttributeEditing());
        });
  }
  return (dispatch) => {
    dispatch(doReceiveUserAttributeList([]));
    dispatch(doInitUserAttributeEditing());
  };
}

export function editUserAttribute(keyNum, userAttribute) {
  return doReceiveUserAttributeEditing({ [keyNum]: userAttribute });
}

export function saveUserAttribute(userAttributeType, secernId, mode) {
  return async (dispatch, getState) => {
    const { editingUserAtribute } = getState().userAttribute;
    const editingUserAtributeKeys = Object.keys(editingUserAtribute);
    if (!editingUserAtributeKeys.length) {
      return null;
    }
    const data = editingUserAtributeKeys.reduce(
      (acc, userAttributeKeyNum) => {
        const userAttribute = editingUserAtribute[userAttributeKeyNum];
        if (userAttribute) {
          acc.userAttributeList.push({ userAttributeKeyNum, userAttribute });
        }
        return acc;
      },
      {
        userAttributeList: [],
        userAttributeType,
        secernId,
      },
    );
    let shouldUpdateAttributes = true;
    if (mode === MODE.NEW_MODE) {
      shouldUpdateAttributes = data.userAttributeList.length > 0;
    }
    if (!shouldUpdateAttributes) {
      return null;
    }
    if (!data.userAttributeList.length) {
      data.userAttributeList = null;
    }
    return userAttributeRequests.postUserAttributeEdit(data);
  };
}

export function doReceiveUserAttributeList(userAttributeList) {
  return {
    type: ActionTypes.USER_ATTRIBUTE_RECEIVE_LIST,
    userAttributeList,
  };
}

export function doInitUserAttributeEditing() {
  return {
    type: ActionTypes.USER_ATTRIBUTE_INIT_EDITING,
  };
}

export function doReceiveUserAttributeEditing(payload) {
  return {
    type: ActionTypes.USER_ATTRIBUTE_RECEIVE_EDITING,
    payload,
  };
}
